export default __webpack_public_path__ + "static/media/2.7a0e41fb.webp";